import Header from '../../../../googleAd/shared/sections/Header'
import { FirstView } from '../../../shared/sections/FirstView'
import EntryForm from '../../../shared/forms/EntryForm'
import { kantoConfig } from './config.ts'
import { StepProvider } from '@/components/Context/StepContext'
import styles from './InstagramKantoFormPage.module.css'
import { KantoSpLandingPageProps } from './types.ts'
import { useAbTestGtm } from '@/components/utils/abTest'

const InstagramKantoFormPage: React.FC<KantoSpLandingPageProps> = ({ prefectures }) => {
    const { dataViewLabel } = useAbTestGtm()

    return(
        <div className={styles.InstagramKantoFormPageWrap}>
            <StepProvider
                initialFormData={{
                    preferLineContact: true,
                    agreeTerms: true
                }}
                initialTouchedFields={{
                    preferLineContact: true,
                    agreeTerms: true,
                    channel: true
                }}
            >
                <Header id='renewal_top' dataViewLabel={dataViewLabel('HD')} />
                <FirstView dataViewLabel={dataViewLabel('CT_FirstView')}/>
                <div className={styles.formWrap}>
                    <EntryForm
                        prefectures={prefectures}
                        config={kantoConfig}
                    />
                </div>
            </StepProvider>
        </div>
    )
}

export default InstagramKantoFormPage
